import React, { useEffect, useState } from 'react';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { initFincode } from "@fincode/js"
import ApiFetch from '../ApiFetch';
import { useLocation, useNavigate } from 'react-router';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Container, Icon, InputLabel, MenuItem, Select } from '@mui/material';
import { Form } from 'react-bootstrap';

// コインチャージ用振込元情報の設定
const ChargeDirectdebitRegist = (props) => {
    function registChargeBank(param){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/chargeBank",param).then((r)=>{
            return r.json()
        })
    }
    function completeChargeBank(param){
      return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/completeChargeBank",param).then((r)=>{
          return r.json()
      })
  }
    function deleteChargeBank(){
      return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/chargeBank").then((r)=>{
          return r.json()
      })
    }
    const [fincode,setFincode] = useState(null)
    const [bankName,setBankName] = useState("")
    const [bankCode,setBankCode] = useState("")
    const [branchName,setBranchName] = useState("")
    const [branchCode,setBranchCode] = useState("")
    const [amount,setAmount] = useState("10000")
    const [bookingDate,setBookingDate] = useState("")
    const [depositType,setDepositType] = useState("")
    const [name,setName] = useState("")
    const [nameHalf,setNameHalf] = useState("")
    const [registStart,setRegistStart] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [complete,setComplete] = useState(props.bank !== undefined && props.bank.status === 1 || false)
    const navigate = useNavigate()

  useEffect(() => {

  },[]);

  function submit(){
    setRegistStart(true)
    registChargeBank({
      "booking_date":bookingDate,
      "amount":amount,
      "name":name,
      "name_half":nameHalf
    }).then(r => {
        if(r.result){
          props.onRegist()
          setRegistStart(false)
          setErrorMessage("")
        } else {
            setRegistStart(false)
            setErrorMessage(r.errors)
        }
    })
  }
  function deleteBankInfo(){
    setRegistStart(true)
    deleteChargeBank().then(r => {
        if(r.result){
            window.location.reload() 
        } else {
            setRegistStart(false)
            setErrorMessage(r.errors)
        }
    })
  }
  return (
    <Card
      variant="outlined"
      sx={{
        maxHeight: 'max-content',
        maxWidth: '100%',
        mx: 'auto',
        // to make the demo resizable
        overflow: 'auto',
        resize: 'horizontal',
      }}
    >
      <Typography level="title-lg" startDecorator={<InfoOutlined />}>
        振込予約
      </Typography>
      <Divider inset="none" />
      <CardContent
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(80px, 1fr))',
          gap: 1.5,
        }}
      >
        <Container sx={{ gridColumn: '1/-1' }}>
          銀行振込でコインをチャージします。<br />
          振込名義と実際の振込名義が異なるとチャージができない場合があります。
        </Container>
        {props.bank === undefined || props.bank.booking_date === undefined ? (<>
        <FormControl>
          <FormLabel>振込名義 (Name)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={name} onChange={(e) => setName(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>振込名義カナ (Name Kana)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={nameHalf} onChange={(e) => setNameHalf(e.target.value)} />
        </FormControl>
        <FormControl>
            <FormLabel>振込予定日</FormLabel>
            <Form.Control
                type="date"
                required
                defaultValue={bookingDate}
                onChange={(e) => setBookingDate(e.currentTarget.value)}
            />
        </FormControl>
        <FormControl sx={{ gridColumn: '1/-1' }}>
            <InputLabel>振込予定金額</InputLabel>
            <Select
                value={amount}
                label="Amount"
                onChange={(e) => {
                  setAmount(e.target.value)
                }}
            >
                {[[... new Array(4)].map((d,i) => {
                    if(i === 0) return
                    return <MenuItem value={((i+1)*1000)}>{((i+1)*1000).toLocaleString()} コイン ({(((i+1)*1000) * 1.25).toLocaleString()} 円)</MenuItem>
                })]}
                {[[... new Array(20)].map((d,i) => {
                    return <MenuItem value={((i+1)*5000)}>{((i+1)*5000).toLocaleString()} コイン ({(((i+1)*5000) * 1.25).toLocaleString()} 円)</MenuItem>
                })]}
            </Select>
        </FormControl>
        コインの有効期限は5カ月です。
        <CardActions sx={{ gridColumn: '1/-1' }}>
          <LoadingButton loading={registStart} variant="contained" color="primary" onClick={() => submit()}>
            振込を予約する
          </LoadingButton>
        </CardActions>
        </>) : ""}
        <Container sx={{ gridColumn: '1/-1' }}>{errorMessage.length > 0 ? <Alert severity='error' className='m-0'>{errorMessage}</Alert> : ""}</Container>
        <Container style={{border:"1px solid #DDDDDD"}} sx={{ gridColumn: '1/-1' }} className='p-3'>
          <Container sx={{ gridColumn: '1/-1' }} className='p-3' style={{color:"#555555",fontSize:"14px",backgroundColor:"#EEEEEE"}}>
            <div>
              <div className='mb-2'>
                <b style={{fontSize:"18px"}}>振込元情報</b>&nbsp;
              </div>
              {props.bank === undefined || props.bank.booking_date === undefined ? "未設定" : (
                <>
                  <table>
                    <tr><th>振込予定日</th><td>{props.bank.booking_date}</td></tr>
                    <tr><th>振込金額</th><td>{(props.bank.amount || 0).toLocaleString()} 円</td></tr>
                  </table>
                </>
              )}
            </div>
            <div className='mt-3'>
              <div className='mb-2'>
                <b style={{fontSize:"18px"}}>振込先情報</b>&nbsp;
              </div>
                {props.bank === undefined || props.bank.booking_date === undefined ? "振込情報登録後に確認できます。" : (
                    <table>
                      <tr><th>銀行名</th><td>GMOあおぞらネット銀行(0310)</td></tr>
                      <tr><th>支店名</th><td>法人営業部(101)</td></tr>
                      <tr><th>口座番号</th><td>1876918</td></tr>
                      <tr><th>受取人名義</th><td>アワート（ド</td></tr>
                    </table>
                )}
            </div>
          </Container>
          {props.bank === undefined || props.bank.booking_date === undefined || complete ? "" : <Alert color='warning' severity='warning' className='mt-2'>購入はまだ完了していません。<br />振込が終わったら、<br />振込完了ボタンを押してください。</Alert>}
          {complete ? <Alert className='mt-2'>振込完了を登録しました。<br />運営が確認して反映するまで<br />しばらくお待ちください。</Alert> : ""}
          <LoadingButton variant='contained' sx={{ gridColumn: '1/-1' }} className="mt-3 w-100" loading={registStart} onClick={() => {
            setRegistStart(true)
            completeChargeBank().then(r => {
              if(r.result){
                setComplete(true)
                setErrorMessage("")
              } else {
                setErrorMessage(r.errors)
              }
              setRegistStart(false)
            })
            }} disabled={props.bank === undefined || props.bank.booking_date === undefined || complete}>
              振込完了
          </LoadingButton>
          <LoadingButton sx={{ gridColumn: '1/-1' }} className="mt-3 w-100" loading={registStart} onClick={() => deleteBankInfo()} disabled={props.bank === undefined || props.bank.booking_date === undefined || complete}>
              振込取消
          </LoadingButton>
        </Container>
      </CardContent>
    </Card>
  );
};

export default ChargeDirectdebitRegist;